import {
  Button,
  LightMode,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
} from "@chakra-ui/react";
import { useTranslate } from "@tolgee/react";
import { useDispatch } from "react-redux";
import PrimaryColorButton from "src/components/PrimaryColorButton";
import {
  EXTERNAL_ACCOUNT_RESET,
  EXTERNAL_ACCOUNT_SET_TIMING_OUT,
} from "src/redux/actions";

function SwitchAccountModal({
  clearSwitchAccount,
  isTimedOut,
}: {
  account?: { companyName: string; companyID: string };
  clearSwitchAccount: () => void;
  isTimedOut: boolean;
}) {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  if (isTimedOut) {
    return (
      <Modal
        isCentered
        isOpen={true}
        onClose={() => dispatch({ type: EXTERNAL_ACCOUNT_RESET })}
      >
        <ModalOverlay />
        <ModalContent>
          <LightMode>
            <ModalBody mt={3}>
              <p style={{ color: "black" }}>
                {t({
                  key: "profile.switchAccounts.sessionTerminated",
                  defaultValue:
                    "Your switch account session has been terminated",
                })}
                .
              </p>
            </ModalBody>
            <ModalFooter
              display="flex"
              justifyContent={"center"}
              alignItems={"center"}
            >
              <PrimaryColorButton
                onClick={() => dispatch({ type: EXTERNAL_ACCOUNT_RESET })}
                colorModeOverride="light"
              >
                {t({
                  key: "profile.switchAccounts.continue",
                  defaultValue: "Continue",
                })}
              </PrimaryColorButton>
            </ModalFooter>
          </LightMode>
        </ModalContent>
      </Modal>
    );
  }

  return (
    <Modal isCentered isOpen={true} onClose={clearSwitchAccount}>
      <ModalOverlay />
      <ModalContent>
        <LightMode>
          <ModalBody mt={3}>
            <p style={{ color: "black" }}>
              {t({
                key: "profile.switchAccounts.inactiveWarning",
                defaultValue:
                  "You are about to switch back to your regular account due to inactivity.",
              })}
            </p>
          </ModalBody>
          <ModalFooter
            display="flex"
            justifyContent={"center"}
            alignItems={"center"}
          >
            <PrimaryColorButton
              onClick={() => {
                dispatch({
                  type: EXTERNAL_ACCOUNT_SET_TIMING_OUT,
                  payload: false,
                });
              }}
              colorModeOverride="light"
              mr="16px"
            >
              {t({
                key: "profile.switchAccounts.continueSession",
                defaultValue: "Continue Session",
              })}
            </PrimaryColorButton>
            <Button variant="solid" onClick={clearSwitchAccount}>
              {t({
                key: "profile.switchAccounts.logOut",
                defaultValue: "Log Out",
              })}
            </Button>
          </ModalFooter>
        </LightMode>
      </ModalContent>
    </Modal>
  );
}

export default SwitchAccountModal;
